import Vconsole from 'vconsole'

let vConsole = new Vconsole();
let count = 0;//点击计数
let lastClickTime = 0;

function hasClass(obj, cls) {
    return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

function addClass(obj, cls) {
    if (!hasClass(obj, cls)) obj.className += " " + cls;
}


function removeClass(obj, cls) {
    if (hasClass(obj, cls)) {
        var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        obj.className = obj.className.replace(reg, ' ');
    }
}


function toggleClass(obj, cls) {
    if (hasClass(obj, cls)) {
        removeClass(obj, cls);
    } else {
        addClass(obj, cls);
    }
}


export default {
    vConsole: vConsole,
    show: () => {
        let vconDom = document.getElementById('__vconsole');
        toggleClass(vconDom, 'show')
    },
    controlShow: () => {
        const nowTime = new Date().getTime();
        if (nowTime - lastClickTime < 3000) {
            count++;
        } else {
            count = 0;
        }
        lastClickTime = nowTime;
        if (count >= 10) {
            let vconDom = document.getElementById('__vconsole');
            toggleClass(vconDom, 'show')
            count = 0;
        }
    }
}
